import React, { useEffect, useState } from "react";
import AdSlot from "./AdSlot";
import "./PageWithSideAds.css";

export default function PageWithSideAds({ children }) {
  const [consent, setConsent] = useState(false);

  useEffect(() => {
    try {
      const v = window.localStorage.getItem("pdfconvert_cookie_consent");
      setConsent(v === "accepted");
    } catch {
      setConsent(false);
    }
  }, []);

  const ADS_CLIENT = "ca-pub-4717440096189113";
  const SLOT_LEFT = "5088070833";
  const SLOT_RIGHT = "7522662480";

  return (
    <div className="page-ads-layout">
      {consent && (
        <aside className="side-ad left" aria-label="Publicité gauche">
          <AdSlot client={ADS_CLIENT} slot={SLOT_LEFT} />
        </aside>
      )}

      <main className="page-content">
        <div className="page-inner">{children}</div>
      </main>

      {consent && (
        <aside className="side-ad right" aria-label="Publicité droite">
          <AdSlot client={ADS_CLIENT} slot={SLOT_RIGHT} />
        </aside>
      )}
    </div>
  );
}
